import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  const location = useLocation();
  
  // Landing page不显示Header和Footer
  const isLandingPage = location.pathname === '/';
  
  if (isLandingPage) {
    return <div className="min-h-screen">{children}</div>;
  }
  
  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <Header />
      <main className="flex-1 container mx-auto px-4 pt-4 max-w-7xl overflow-hidden">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
